import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CardActions from '@mui/material/CardActions';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Image from 'next/image';
import { CmsImage } from '@/components/CmsImage';
import MediaCard from '@/components/MediaCard';
import { VehicleAttribute } from '@/components/Vehilces/VehicleAttribute';
import { VehicleEnquireNowModal } from '@/components/Vehilces/VehicleEnquireNowModal';
import { VehicleSpecChips } from '@/components/Vehilces/VehicleSpecChips';
import { formatCurrency } from '@/lib/formatCurrency';
import { urlForCmsLink } from '@/lib/urlForCmsLink';
import type { CmsVehicle } from '@/services/cms/models/CmsVehicle';
export interface VehicleMediaCardProps {
  vehicle: CmsVehicle;
  enquireFormOnCompleteMessage?: string;
  siteId?: number;
}
export function VehicleMediaCard(t0) {
  const $ = _c(25);
  const {
    vehicle,
    enquireFormOnCompleteMessage,
    siteId
  } = t0;
  let t1;
  let t2;
  if ($[0] !== vehicle) {
    t1 = <VehicleMediaCardImage vehicle={vehicle} />;
    t2 = <VehicleMediaCardTitle vehicle={vehicle} />;
    $[0] = vehicle;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== enquireFormOnCompleteMessage || $[4] !== siteId || $[5] !== vehicle) {
    t3 = <VehicleMediaCardActions vehicle={vehicle} siteId={siteId} enquireFormOnCompleteMessage={enquireFormOnCompleteMessage} />;
    $[3] = enquireFormOnCompleteMessage;
    $[4] = siteId;
    $[5] = vehicle;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `vehicle-${vehicle.stockId}`;
  let t5;
  if ($[7] !== vehicle) {
    t5 = <VehicleMediaCardPrice vehicle={vehicle} />;
    $[7] = vehicle;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== vehicle.berths || $[10] !== vehicle.odometer || $[11] !== vehicle.year) {
    t6 = <VehicleSpecChips year={vehicle.year} berths={vehicle.berths} odometer={vehicle.odometer} />;
    $[9] = vehicle.berths;
    $[10] = vehicle.odometer;
    $[11] = vehicle.year;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  let t8;
  if ($[13] !== vehicle) {
    t7 = <VehicleMediaCardAttributesGrid vehicle={vehicle} />;
    t8 = <VehicleMediaCardSummary vehicle={vehicle} />;
    $[13] = vehicle;
    $[14] = t7;
    $[15] = t8;
  } else {
    t7 = $[14];
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t1 || $[17] !== t2 || $[18] !== t3 || $[19] !== t4 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7 || $[23] !== t8) {
    t9 = <MediaCard image={t1} title={t2} actions={t3} transitionName={t4}>{t5}{t6}{t7}{t8}</MediaCard>;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
}
type VehicleMediaCardTitleProps = {
  vehicle: VehicleMediaCardProps['vehicle'];
};
function VehicleMediaCardTitle(t0) {
  const $ = _c(3);
  const {
    vehicle
  } = t0;
  if (vehicle.url) {
    let t1;
    if ($[0] !== vehicle.title || $[1] !== vehicle.url) {
      t1 = <Link href={vehicle.url} underline="none">{vehicle.title}</Link>;
      $[0] = vehicle.title;
      $[1] = vehicle.url;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  return vehicle.title;
}
type VehicleMediaCardActionsProps = VehicleMediaCardProps;
function VehicleMediaCardActions(t0) {
  const $ = _c(11);
  const {
    vehicle,
    enquireFormOnCompleteMessage,
    siteId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      justifyContent: "space-around"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== vehicle.url) {
    t2 = vehicle.url ? <Button size="small" href={urlForCmsLink(vehicle.url)}>View More</Button> : null;
    $[1] = vehicle.url;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `Contact us about the ${vehicle.title}`;
  let t4;
  if ($[3] !== enquireFormOnCompleteMessage || $[4] !== siteId || $[5] !== t3 || $[6] !== vehicle.stockId) {
    t4 = <VehicleEnquireNowModal vehicleStockId={vehicle.stockId} title={t3} siteId={siteId} onCompleteMessage={enquireFormOnCompleteMessage} />;
    $[3] = enquireFormOnCompleteMessage;
    $[4] = siteId;
    $[5] = t3;
    $[6] = vehicle.stockId;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <CardActions sx={t1}>{t2}{t4}</CardActions>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
type VehicleMediaCardImageProps = {
  vehicle: VehicleMediaCardProps['vehicle'];
};
function VehicleMediaCardImage(t0) {
  const $ = _c(7);
  const {
    vehicle
  } = t0;
  const image = vehicle.images[0]?.image;
  let t1;
  if ($[0] !== image) {
    t1 = image?.link ? <CmsImage {...image} sizes="(max-width: 412px) 380px, (max-width: 600px) 276, (max-width: 900px) 426, (max-width: 1536px) 364" /> : <Image src="/images/place-holder.svg" width={343} height={205} alt="Image coming soon" unoptimized={true} />;
    $[0] = image;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const children = t1;
  if (vehicle.url) {
    let t2;
    if ($[2] !== vehicle.url) {
      t2 = urlForCmsLink(vehicle.url);
      $[2] = vehicle.url;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== children || $[5] !== t2) {
      t3 = <Link href={t2}>{children}</Link>;
      $[4] = children;
      $[5] = t2;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  return children;
}
type VehicleMediaCardPriceProps = {
  vehicle: VehicleMediaCardProps['vehicle'];
};
function VehicleMediaCardPrice(t0) {
  const $ = _c(11);
  const {
    vehicle
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      fontWeight: "bold"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== vehicle.discountedPrice || $[2] !== vehicle.price || $[3] !== vehicle.region) {
    t2 = vehicle.discountedPrice ? <><Box component="span" sx={{
        textDecoration: "line-through"
      }}>{formatCurrency(vehicle.price, vehicle.region)}</Box>{" "}</> : null;
    $[1] = vehicle.discountedPrice;
    $[2] = vehicle.price;
    $[3] = vehicle.region;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = vehicle.discountedPrice || vehicle.price;
  let t4;
  if ($[5] !== t3 || $[6] !== vehicle.region) {
    t4 = formatCurrency(t3, vehicle.region);
    $[5] = t3;
    $[6] = vehicle.region;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <Typography variant="body1" gutterBottom={true} sx={t1}>{t2}{t4}</Typography>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
type VehicleMediaCardAttributesGridProps = {
  vehicle: VehicleMediaCardProps['vehicle'];
};
function VehicleMediaCardAttributesGrid(t0) {
  const $ = _c(17);
  const {
    vehicle
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      xs: 12,
      sm: 6
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== vehicle.make) {
    t2 = <Grid size={t1}><VehicleAttribute title={vehicle.make} caption="Make" /></Grid>;
    $[1] = vehicle.make;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      xs: 12,
      sm: 6
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== vehicle.model) {
    t4 = <Grid size={t3}><VehicleAttribute title={vehicle.model} caption="Model" /></Grid>;
    $[4] = vehicle.model;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      xs: 12,
      sm: 6
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== vehicle.location) {
    t6 = <Grid size={t5}><VehicleAttribute title={vehicle.location} caption="Current location" /></Grid>;
    $[7] = vehicle.location;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      xs: 12,
      sm: 6
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== vehicle.stockId) {
    t8 = <Grid size={t7}><VehicleAttribute title={vehicle.stockId} caption="Stock number" /></Grid>;
    $[10] = vehicle.stockId;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t2 || $[13] !== t4 || $[14] !== t6 || $[15] !== t8) {
    t9 = <Grid container={true} spacing={2}>{t2}{t4}{t6}{t8}</Grid>;
    $[12] = t2;
    $[13] = t4;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}
type VehicleMediaCardSummaryProps = {
  vehicle: VehicleMediaCardProps['vehicle'];
};
function VehicleMediaCardSummary(t0) {
  const $ = _c(2);
  const {
    vehicle
  } = t0;
  let t1;
  if ($[0] !== vehicle.summary) {
    t1 = vehicle.summary ? <Typography sx={{
      mt: 2
    }} variant="body2">{vehicle.summary}</Typography> : null;
    $[0] = vehicle.summary;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}